import {
  APPROVED_THROUGH_DIY_FLOW_USER_STATUS,
  APPROVED_USER_STATUS,
  USER_IN_REVIEW,
  USER_IS_WAITLISTED,
} from "./constants";

export const isReviewOrRejectedOnboardingStatus = (status) =>
  status === USER_IN_REVIEW || status === USER_IS_WAITLISTED;

export const getPostAuthDestination = (userData) => {
  if (!userData) {
    return null;
  }

  if (isReviewOrRejectedOnboardingStatus(userData.status)) {
    return "/register/status";
  }

  const hasBrand = Boolean(userData.brand || userData.parent_brand?.id);
  const hasOnboardingApplication = Boolean(userData.onboarding_application_id);
  const isApprovedUser =
    userData.status === APPROVED_USER_STATUS ||
    userData.status === APPROVED_THROUGH_DIY_FLOW_USER_STATUS;

  if (isApprovedUser && hasBrand) {
    return "/dashboard/home";
  }
  if (hasBrand || isApprovedUser || hasOnboardingApplication) {
    return "/";
  }
  return "/register";
};

// Signup never grants dashboard access now: every outcome lands on the status screen.
export const shouldRouteToRegisterStatusAfterSignup = (registrationStatus) =>
  registrationStatus === "waitlisted" ||
  registrationStatus === "rejected" ||
  registrationStatus === "in_review";
